<template>
    <div class="feedbackReport">
      <div class="page-navbar">
        <div class="show-main">
          <div class="export-show">
            <div class="export-title">{{titleInfoData.reportName}}</div>
            <div class="export-info">
              学校：{{titleInfoData.schoolName}}<br />
              视导日期：{{titleInfoData.supervisionDate}}
            </div>
            <div class="export-content">
              <div class="big-title">
                <van-icon :name="require('@/assets/img/manage/export-01.png')" />
                1、课堂教学
              </div>
              <div class="title">1.1 课堂维度评价</div>
              <div class="content" v-for="(item,index) in dimensionData" :key="index">
                {{index+1}}.{{item.stem}}
                <div class="circle">
                  <div class="item">
                    <van-circle
                      v-model="item['rate'+index+1]"
                      :rate="Number(item.good*100)"
                      :speed="100"
                      size="50"
                      color="#00C885"
                      layer-color="#D2D2D2"
                      stroke-width="80"
                      :text="Number(item.good*100)+'%'"
                      :clockwise="false"
                    />
                    <div>优</div>
                  </div>
                  <div class="item">
                    <van-circle
                      v-model="item['rate'+index+2]"
                      :rate="Number(item.fine*100)"
                      :speed="100"
                      size="50"
                      color="#00AEFF"
                      layer-color="#D2D2D2"
                      stroke-width="80"
                      :text="Number(item.fine*100)+'%'"
                      :clockwise="false"
                    />
                    <div>良</div>
                  </div>
                  <div class="item">
                    <van-circle
                      v-model="item['rate'+index+3]"
                      :rate="Number(item.pass*100)"
                      :speed="100"
                      size="50"
                      color="#00CCFF"
                      layer-color="#D2D2D2"
                      stroke-width="80"
                      :text="Number(item.pass*100)+'%'"
                      :clockwise="false"
                    />
                    <div>合格</div>
                  </div>
                  <div class="item">
                    <van-circle
                      v-model="item['rate'+index+4]"
                      :rate="Number(item.fail*100)"
                      :speed="100"
                      size="50"
                      color="#FF0E52"
                      layer-color="#D2D2D2"
                      stroke-width="80"
                      :text="Number(item.fail*100)+'%'"
                      :clockwise="false"
                    />
                    <div>不合格</div>
                  </div>
                </div>
              </div>
              <div class="title">1.2 课堂综合评定</div>
              <div class="content">
                <div class="echarts">
                  <div class="round-pie">
                    <CunwEcharts
                      id="main"
                      :chart-data="options"
                      class="echarts"
                      style="width: 140px; height: 140px"
                    ></CunwEcharts>
                  </div>
                  <div class="text">
                    <div class="c-title">听课节数：{{synthesizeData.totalSize}}节</div>
                    <div><i class="green"></i>其中优课：{{synthesizeData.goodSize}}节，占{{parseInt(synthesizeData.goodSize/synthesizeData.totalSize*100)}}%</div>
                    <div><i class="blue"></i>良 课：{{synthesizeData.fineSize}}节，占{{parseInt((synthesizeData.fineSize/synthesizeData.totalSize)*100)}}%</div>
                    <div><i class="blue-o"></i>合格课：{{synthesizeData.passSize}}节，占{{parseInt((synthesizeData.passSize/synthesizeData.totalSize)*100)}}%</div>
                    <div><i class="red"></i>不合格课：{{synthesizeData.failSize}}节，占{{parseInt((synthesizeData.failSize/synthesizeData.totalSize)*100)}}%</div>
                  </div>
                </div>
              </div>
              <div class="title">1.3 课堂综合评语</div>
              <!-- <div class="comment-items">
                <div class="h3">
                  <van-icon :name="require('@/assets/img/manage/icon.png')" />
                  优势和亮点汇总
                </div>
                <div class="mark" v-html="positiveData.positiveCollect"></div>
              </div>
              <div class="comment-items">
                <div class="h3">
                  <van-icon :name="require('@/assets/img/manage/icon.png')" />
                  问题和建议汇总
                </div>
                <div class="mark" v-html="positiveData.questionCollect"></div>
              </div> -->
              <div class="comment-items">
                <!-- <div class="h3">
                  <van-icon :name="require('@/assets/img/manage/icon.png')" />
                  综合评价
                </div> -->
                <div class="mark">
                  {{positiveData.finalEvaluation}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="teaching-routine" v-for="(category, categoryIndex) in lookupCategoryList" :key="categoryIndex">
          <div class="teaching-title">
            <span v-if="category.iconType === 'bookshelf'" class="bg-icon icon-bookshelf"></span>
            <van-icon v-else :name="category.iconPath" />
            <p>{{category.index}}、{{category.name}}</p>
          </div>
          <div class="teaching-context" v-for="(item,index) in category.items" :key="index">
            <p class="title">{{item.stem}}</p>
            <div class="context" v-html="item.textAnswer&&('<p>'+item.textAnswer.replace(/\n/g, '</p><p>') + '</p>')"></div>
            <div class="img-box">
              <img v-for="(v,i) in item.pictureAnswers" :key="i" :src="v" />
            </div>
          </div>
        </div>
      </div>
      <div class="remark-box">
        <p>芙蓉区教育科研中心</p>
        <p>{{reportDate}}</p>
      </div>
    </div>
</template>
<script>
import CunwEcharts from '@/components/CunwEcharts/index.vue'; // 组件
import { getDimensionAssess, getSynthesizeAssess, getLookupCategoryAssess, getPositiveQuestionAssess, getNoticeTileInfo } from '@/api/teacher/report';
const typeName = {
  'goodSize': '优',
  'fineSize': '良',
  'passSize': '合格',
  'failSize': '不合格'
};
const styleName = {
  'goodSize': '#00C885',
  'fineSize': '#00AEFF',
  'passSize': '#00CCFF',
  'failSize': '#FF0E52'
};
export default {
  components: {
    CunwEcharts
  },
  data() {
    return {
      options: {
        totalSize: '',
        data: []
      },
      typeName,
      styleName,
      planId: '',
      dimensionData: [],
      synthesizeData: {},
      lookupData: {},
      positiveData: {},
      titleInfoData: {},
      reportDate: '',
      categoryIconMap: {
        '教学常规': { iconType: 'bookshelf' },
        '德育工作': { iconType: 'icon', iconPath: require('@/assets/img/icon7.png') },
        '科研成果': { iconType: 'icon', iconPath: require('@/assets/img/icon3.png') },
        '校本研训': { iconType: 'icon', iconPath: require('@/assets/img/icon4.png') },
        '课程实施': { iconType: 'icon', iconPath: require('@/assets/img/icon5.png') },
        '课程建设': { iconType: 'icon', iconPath: require('@/assets/img/icon5.png') },
        '心理教育': { iconType: 'icon', iconPath: require('@/assets/img/icon6.png') }
      }
    };
  },
  computed: {
    lookupCategoryList() {
      if (!this.lookupData.lookUpAnswerMap || Object.keys(this.lookupData.lookUpAnswerMap).length === 0) {
        return [];
      }
      const categoryList = [];
      let index = 2;
      for (const [categoryName, items] of Object.entries(this.lookupData.lookUpAnswerMap)) {
        if (items && items.length > 0) {
          const iconInfo = this.categoryIconMap[categoryName] || { iconType: 'icon', iconPath: require('@/assets/img/icon3.png') };
          categoryList.push({
            name: categoryName,
            items: items,
            index: index++,
            iconType: iconInfo.iconType,
            iconPath: iconInfo.iconPath
          });
        }
      }
      return categoryList;
    }
  },
  created() {
    this.planId = this.$route.query.planId;
    this.getDimensionInfo();
    this.getSynthesizeInfo();
    this.getLookupCategoryInfo();
    this.getPositiveQuestionInfo();
    this.getTitleInfo();
  },
  methods: {
    // 课堂维度评价
    getDimensionInfo() {
      getDimensionAssess(this.planId).then(res => {
        this.dimensionData = res.data.d;
      });
    },
    // 课堂综合评价
    getSynthesizeInfo() {
      getSynthesizeAssess(this.planId).then(res => {
        this.synthesizeData = res.data;
        this.options.totalSize = res.data.totalSize;
        for (const key in res.data) {
          if (key !== 'totalSize') {
            this.options.data.push({ value: res.data[key], name: typeName[key], itemStyle: { color: styleName[key] }});
          }
        }
      });
    },
    // 课堂综合评语
    getPositiveQuestionInfo() {
      getPositiveQuestionAssess(this.planId).then(res => {
        this.positiveData = res.data;
      });
    },
    // 课堂综合评语-六个维度
    getLookupCategoryInfo() {
      getLookupCategoryAssess(this.planId).then(res => {
        this.lookupData = res.data;
      });
    },
    getTitleInfo() {
      getNoticeTileInfo(this.planId).then(res => {
        this.titleInfoData = res.data;
        const dates = res.data.reportDate.split('-');
        this.reportDate = dates[0] + '年' + dates[1] + '月' + dates[2] + '日';
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
.remark-box{
  text-align: right;
  margin:20px 15px 30px 0;
  font-size: 12px;
  color: #333333;
  line-height: 20px;
}
.teaching-routine{
  border-radius: 5px;
  background-color: white;
  margin: 10px 15px;
  padding: 20px 15px;
  .teaching-title{
    display: flex;
    align-items: center;
    .van-icon__image{
      width: 16px;
      height: 16px;
    }
    .icon-bookshelf{
      width: 16px;
      height: 16px;
      background-image: url('../../../../assets/img/icon-bookshelf.png');
    }
    p{
      font-size: 15px;
      font-weight: bold;
      color: #333333;
      margin-left: 10px;
    }
  }
  .teaching-context{
    margin-top: 20px;
    .title{
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }
    .context{
      font-size: 13px;
      color: #333333;
      line-height: 18px;
      margin: 8px 0 14px;
      ::v-deep p{
        text-indent: 2em;
        margin: 0.2em 0;
      }
    }
    .img-box{
      text-align: center;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
}
.show-main{
  background-color: white;
  margin: 12px 15px;
}
.export-show {
    padding: 12px 15px;
    border-radius: 5px;
    color: #333;
}

.export-title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding-bottom: 13px;
    padding-top: 5px;
    border-bottom: 3px solid $blue;
}

.export-info {
    margin-top: 2px;
    border-top: 1px solid $blue;
    padding: 10px 0;
    border-bottom: 1px dashed #bbb;
    font-size: 12px;
}

.export-content {
    padding: 15px 0;
}

.export-content .big-title {
    font-size: 15px;
    line-height: 25px;
    font-weight: bold;
}

.export-content .title {
    font-size: 14px;
    font-weight: bold;
    margin: 10px 0 0 0;
}

.export-content .content {
    font-size: 13px;
    padding: 15px 0;
    border-bottom: 1px dashed #bbb;
}

.export-content .van-icon {
    top: 3px;
    margin-right: 5px;
}

.export-content .van-icon img {
    width: 18px;
    height: 18px;
}

.circle {
    margin: 8px 20px 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.circle .item {
    text-align: center;
}

.echarts {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.echarts .round-pie {
    width: 165px;
}

.echarts .text {
    flex: 1;
}

.echarts .c-title {
    font-weight: bold;
    margin-bottom: 5px;
    font-size: 14px;
}

.echarts i {
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #333;
    position: relative;
    top: -3px;
    margin-right: 8px;
}

.echarts i.green {
    background-color: #00c885;
}

.echarts i.blue {
    background-color: #00aeff;
}

.echarts i.blue-o {
    background-color: #00ccff;
}

.echarts i.red {
    background-color: #ff0e52;
}

.comment-items {
    margin-top: 15px;
}

.comment-items .van-icon {
    margin-right: 0;
}

.comment-items .van-icon img {
    width: 15px;
    height: 15px;
}

.export-show .h3 {
    font-weight: bold;
    font-size: 14px;
    margin: 6px auto;
}

.export-show .mark {
    margin-left: 18px;
    font-size: 13px;
    ::v-deep p{
      width: 100%;
      line-height: 25px;
      word-break: break-all;
    }
}
</style>
